import { parse } from "~/lib/date";

// Normalize common date strings to ISO before formatting
export const normalizeDate = (value: string): string | null => {
  // MM/DD/YY or MM/DD/YYYY
  const mmdd2 = /^\d{1,2}\/\d{1,2}\/\d{2}$/;

  try {
    if (mmdd2.test(value)) {
      const d = parse(value, "MM/dd/yy", new Date());
      return d.toISOString();
    }

    // Generic ISO-like strings with delimiters
    // Must start with a digit to be considered a date (e.g., "2024-01-15", "01/15/2024")
    // This prevents arbitrary strings like "aarch64" or "some-tag" from being parsed
    if (/^\d/.test(value) && /[T:\-\/]/.test(value)) {
      const d = new Date(value);
      const t = d.getTime();
      // Additional sanity check: year should be reasonable (1970-2100)
      const year = d.getFullYear();
      if (Number.isNaN(t) || year < 1970 || year > 2100) {
        return null;
      }
      return d.toISOString();
    }

    return null;
  } catch {
    return null;
  }
};
